import type { GeoLocation } from '@bambi/api-client/schemas';

import type { GeolocationFormValues } from './types';

export const defaultFormValues: GeolocationFormValues = {
  id: undefined,
  label: '',
  coordinates: undefined,
};

export const assignDefaultFormValues = (
  geolocation: GeoLocation | undefined
): GeolocationFormValues => {
  if (!geolocation) return defaultFormValues;

  return {
    id: geolocation.id,
    label: geolocation.label,
    coordinates: {
      latitude: geolocation.location.latitude,
      longitude: geolocation.location.longitude,
    },
  };
};
